<template>
  <div class="card-text"><slot></slot></div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  name: 'CardText',
  setup() {
    
  },
})
</script>


<style scoped>
.card-text {
  font-size: 1.15rem;
  text-align: justify;
  margin: 1rem;
  font-weight: lighter;
}
</style>
